import { render, staticRenderFns } from "./registrations-table-view-dialog.vue?vue&type=template&id=f68f6846&scoped=true"
import script from "./registrations-table-view-dialog.js?vue&type=script&lang=js&external"
export * from "./registrations-table-view-dialog.js?vue&type=script&lang=js&external"
import style0 from "./registrations-table-view-dialog.vue?vue&type=style&index=0&id=f68f6846&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68f6846",
  null
  
)

export default component.exports